import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import modules from './modules';
import 'babel-polyfill';

export default () => new Vuex.Store({
    plugins: [
        createPersistedState({
            storage: window.sessionStorage
        })
    ],
    modules
});



// WEBPACK FOOTER //
// ./src/store/index.js